/**
 * Retorna o texto amigável do status para exibição ao cliente
 */
export function getStatusLabel(status: string): string {
  const statusMap = {
    solicitado: "Solicitado",
    pendente: "Pendente",
    pedido_liberado: "Pedido liberado",
    em_producao: "Em produção",
    em_aprovacao: "Em aprovação",
    pronto_para_imprimir: "Pronto para imprimir",
    concluida: "Concluída",
    concluido: "Concluído",
    conferido: "Conferido",
    cancelada: "Cancelada",
    canceladp: "Cancelado",
    error: "Erro no processamento",
    duplicidade: "Pedido duplicado",
    "a fazer": "A fazer",
    "a aprovar": "Aguardando aprovação",
    "enviar pdf": "Aguardando envio do PDF",
    envio_de_dados: "Envio de dados",
  };

  //@ts-expect-error
  return statusMap[status] ?? "Status desconhecido";
}
